import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEventType, HttpResponse, HttpResponseBase, HttpErrorResponse } from '@angular/common/http'
import { catchError } from 'rxjs/operators/catchError';
import { _throw } from 'rxjs/observable/throw';
import { movieVM } from '../../models/movieVM';
import { AppConstants } from '../../constants/siteConstants';


@Injectable()
export class LoginService {
  constructor(private http: HttpClient) { }

 
userLogin(model: any) {
  return this.http.post(`${AppConstants.baseURL}/admin/login`, model);
}

private handleError(error: HttpErrorResponse) {
    debugger;
    let errMsg = '';
    // Client Side Error
    if (error.error instanceof ErrorEvent) {
      errMsg = `Error: ${error.error.message}`;
    }
    else {  // Server Side Error
      errMsg = `Error Code: ${error.status},  Message: ${error.message}`;
    }
    // return an observable
    return _throw(errMsg);
  };

}



// WEBPACK FOOTER //
// ./src/app/services/login/login.service.ts